import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { buildQrQueryString, parseQrParams } from "../utils/queryParams";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    const qrParams = parseQrParams(location.search);
    return <Navigate to={`/login${buildQrQueryString(qrParams)}`} replace />;
  }

  return children;
}
